const WhatTypeOfPlaceDoYouPrefer = Object.freeze({
  BOUTIQUE_SMALL_CHARACTERFUL: 'boutique_small_characterful',
  DESIGN_HOTEL_STYLISH_MODERN: 'design_hotel_stylish_modern',
  RESORT_SPACE_FACILITIES: 'resort_space_facilities',
  HOME_OR_APARTMENT: 'home_or_apartment',

  // Retained so existing saved DNA remains valid.
  LARGE_CHAIN_RELIABLE: 'large_chain_reliable',
  NO_STRONG_PREFERENCE: 'no_strong_preference',
} as const);

export type WhatTypeOfPlaceDoYouPrefer =
  (typeof WhatTypeOfPlaceDoYouPrefer)[keyof typeof WhatTypeOfPlaceDoYouPrefer];

export const allWhatTypeOfPlaceDoYouPrefer: [
  WhatTypeOfPlaceDoYouPrefer,
  ...WhatTypeOfPlaceDoYouPrefer[],
] = Object.values(WhatTypeOfPlaceDoYouPrefer) as [
  WhatTypeOfPlaceDoYouPrefer,
  ...WhatTypeOfPlaceDoYouPrefer[],
];

export default WhatTypeOfPlaceDoYouPrefer;